import { Box } from "@chakra-ui/react";

import { useSelector } from "react-redux";
import { getReportDescription } from "../../store/helpers";
import TicketsPerAgentReport from "../../components/branches/reports/TicketsPerAgent";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const TicketsPerAgent = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;

  const title = `${reportIndex || ""}. Tickets Per Agent`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  //requires array of objects
    if (!_.isArray(data)) {
      data = [data];
    }  
    
  return (
    <Box>
      <h1>{title}</h1>
        <p>{getReportDescription(reportRange).TicketsByAgents}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <span className="reportPresentationSummaryLabel">Presentation</span>
            <span className="reportPresentationSummaryValue">
              {presentationSummaryItems.join(" / ")}
            </span>
          </div>
        ) : null}
        {!_.isEmpty(data) ? (
          <>
            <TicketsPerAgentReport reportIndex={reportIndex} data={data} />
          </>
        ) : (
          <Box mt={10}>
            <p>No data available in this report</p>
          </Box>
        )}
    </Box>
  );
};

export default TicketsPerAgent;
